import styled from 'styled-components';

export const ULSignUpContainer = styled.div`
    display: flex;
    justify-content: center;
    min-height: 900px;
`;

export const SignUpLayout = styled.div`
    display: flex;
    justify-content: center;
    padding-top: 20px;
`;

export const SignUpContainer = styled.div`
    min-width: 500px;
    padding-top: 16px;
    border-radius: 20px;
    background-color: white;
`

export const SignUpTitle = styled.p`
    font-weight: 500;
    font-size: 24px;
    padding: 0 24px 8px 24px;
    text-align: left;
    font-family: kite-mallory, "Helvetica Neue", Helvetica, Arial, sans-serif;
`

export const SwitchPartnerTypeHint = styled.p`
    margin: -4px 0 12px;
    padding: 0 24px;
    text-align: left;
    font-size: 14px;
    font-weight: 400;
    color: #6f6f6f;
    font-family: kite-mallory, "Helvetica Neue", Helvetica, Arial, sans-serif;

    a {
        font-weight: 500;
    }
`

